import { Box, Flex, Text } from '@chakra-ui/react';
import { getIn } from 'formik';
import * as lodash from 'lodash';
import React from 'react';

import { CreditAgreementFullArtifactWipConfigType } from '../../types';
import { createReportingXlsxConfigShell } from '../entity/reporting/ReportingConfig';
import { ReportingTable } from '../entity/reporting/ReportingTable';
import { AddIconButton } from 'packages/common-frontend/components/IconButton';
import { StickyHeaderSection } from 'packages/common-frontend/components/StickyHeaderSection';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

const { compact } = lodash;

const BASE_PROPERTY_KEY = 'reportingMechanics';

const createReportingXlsxPropertyShell = (
  idx: number,
): CreditAgreement.DomainEntity.ReportingProperty => ({
  type: CreditAgreement.DomainEntity.PropertyType.ReportProperty,
  name: `[ Report Placeholder ${idx} ]`,
  value: '[ Description Placeholder ]',
  reportConfigTypes: ['monthlyServicerReport'],
  _config_: createReportingXlsxConfigShell(),
  _isWrittenIn_: false,
});

const addReportingProperty = (param: {
  wipConfig: CreditAgreementFullArtifactWipConfigType;
}) => {
  const { formProps } = param.wipConfig;

  const reportingMechanicsSection = getIn(formProps.values, BASE_PROPERTY_KEY);

  formProps.setFieldValue(BASE_PROPERTY_KEY, [
    ...reportingMechanicsSection,
    createReportingXlsxPropertyShell(reportingMechanicsSection.length),
  ]);
};

type ReportingMechanicsProps = {
  reportingMechanics: CreditAgreement.DomainEntity.ReportingMechanics;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  organizationId: string;
  creditAgreementId: string;
  bankAccounts: CreditAgreement.DomainEntity.Items.BankAccountEntity[];
};
export const ReportingMechanics = ({
  reportingMechanics,
  wipConfig,
  organizationId,
  creditAgreementId,
  bankAccounts,
}: ReportingMechanicsProps) => {
  if (
    !wipConfig?.isMutateAllowed(BASE_PROPERTY_KEY) &&
    !compact(reportingMechanics).length
  ) {
    return null;
  }

  return (
    <Box mt="40px" id="reporting-mechanics-main-container">
      <StickyHeaderSection labelText="Reporting Mechanics">
        <Flex alignItems="center" mb="2">
          <Text fontWeight="bold" fontSize="20px" mr="1">
            Report
          </Text>

          {wipConfig?.isMutateAllowed(BASE_PROPERTY_KEY) && (
            <AddIconButton
              ariaLabel="add report"
              label="Add Report"
              onClick={() => {
                addReportingProperty({ wipConfig });
              }}
            />
          )}
        </Flex>

        <ReportingTable
          organizationId={organizationId}
          creditAgreementId={creditAgreementId}
          reportingMechanics={reportingMechanics}
          basePropertyKey={BASE_PROPERTY_KEY}
          wipConfig={wipConfig}
          bankAccounts={bankAccounts}
        />
      </StickyHeaderSection>
    </Box>
  );
};
